module.exports = __webpack_public_path__ + "img/exam (3).18e044ab.jpeg";